import React from "react";
import styled, { css } from "styled-components";

import { EditorVariant } from "../types";

import EditorStyles from "./EditorStyles";

type Props = {
  className?: string;
  variant: EditorVariant;
};

const EditorPlaceholderStyles = styled.div<{ variant: EditorVariant }>`
  border: ${({ variant }) =>
    variant !== "seamless" && css`1px solid var(--ck-color-base-border)`};
  border-radius: var(--ck-border-radius);
  background-color: #eee;

  height: 100%;

  .toolbar {
    ${({ variant }) =>
      variant === "classic"
        ? css`
            border-bottom: 1px solid var(--ck-color-base-border);
            height: calc(
              var(--ck-icon-size) + (var(--ck-spacing-small) * 2) +
                (var(--ck-spacing-tiny) * 2)
            );
          `
        : css`
            display: none;
          `}
  }

  .content {
    height: calc(
      1.22rem + 0.6rem + var(--ck-spacing-large) + var(--ck-spacing-standard)
    );
  }
`;

const EditorPlaceholder = ({ className, variant }: Props) => {
  return (
    <EditorStyles className={className} variant={variant} isFocused={false}>
      <EditorPlaceholderStyles variant={variant}>
        <div className="toolbar">&nbsp;</div>
        <div className="content">&nbsp;</div>
      </EditorPlaceholderStyles>
    </EditorStyles>
  );
};

export default EditorPlaceholder;
